import { render, staticRenderFns } from "./FundStatus.vue?vue&type=template&id=20cad058&scoped=true&"
import script from "./FundStatus.vue?vue&type=script&lang=js&"
export * from "./FundStatus.vue?vue&type=script&lang=js&"
import style0 from "./FundStatus.vue?vue&type=style&index=0&id=20cad058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cad058",
  null
  
)

export default component.exports